<div class="print_packing" *ngFor="let shipStationOrder of single? [shipStationOrders[shipStationOrders.length-1]]:shipStationOrders;let i=index">
    <hr>
    <h4 class="print_packing_subtitle">{{shipOrder(shipStationOrder?.orderKey)?.account || shipOrder(shipStationOrder?.orderKey)?.Account}} </h4>
    <p class="print_packing_text_info print_packing_ship_to_text">
        {{shipOrder(shipStationOrder?.orderKey)?.addressln1 || shipOrder(shipStationOrder?.orderKey)?.Addressln1}} <br>
        {{shipOrder(shipStationOrder?.orderKey)?.city || shipOrder(shipStationOrder?.orderKey)?.City }}, 
        {{shipOrder(shipStationOrder?.orderKey)?.state || shipOrder(shipStationOrder?.orderKey)?.State}} {{shipOrder(shipStationOrder?.orderKey)?.fromPostalCode || shipOrder(shipStationOrder?.orderKey)?.FromPostalCode}} <br>
        {{shipOrder(shipStationOrder?.orderKey)?.CountryCode}}
    </p>
    <div class="print_packing_ship_info">
        <div class="print_packing_address_info print_packing_ship_to">
            <p class="print_packing_text_info"><b>Ship To</b></p>
            <p class="print_packing_text_info print_packing_ship_to_text ">
                {{shipStationOrder?.shipTo?.name}} <br>
                {{shipStationOrder?.shipTo?.street1}} <br>
                {{shipStationOrder?.shipTo?.city}}, {{shipStationOrder?.shipTo?.state}}
                {{shipStationOrder?.shipTo?.postalCode}}<br>
                {{shipStationOrder?.shipTo?.country}}
            </p>
        </div>
        <div class="print_packing_address_info print_packing_detail_info">
            <p class="print_packing_order_info">
                <span class="print_packing_text_info print_packing_text_info_width">Order : </span>
                <span class="print_packing_text_info">{{shipStationOrder?.orderNumber}} </span>
            </p>
            <p class="print_packing_order_info">
                <span class="print_packing_text_info print_packing_text_info_width">Date : </span>
                <span class="print_packing_text_info">{{shipStationOrder?.orderDate | date:
                    'MM/dd/yyyy'}} </span>
            </p>
            <p class="print_packing_order_info">
                <span class="print_packing_text_info print_packing_text_info_width">Ship date : </span>
                <span class="print_packing_text_info">{{shipStationOrder?.shipByDate | date:
                    'MM/dd/yyyy'}} </span>
            </p>
        </div>
    </div>

    <div class="print_packing_table">
        <table class="table">
            <thead>
                <tr>
                    <th scope="col" class="text-end">#</th>
                    <th scope="col" colspan="2">Item</th>
                    <th scope="col" class=" text-end">Qty</th>
                    <th scope="col" class=" text-end ">Total</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of shipStationOrder.items;let i=index;">
                    <td scope="row">{{i+1}} </td>
                    <td colspan="2">
                        {{item?.name}}
                    </td>
                    <td class="text-end">{{item?.quantity}} </td>
                    <td class="text-end">${{item?.quantity* item?.unitPrice | number : '1.2-2'}} </td>
                </tr>
                <tr class="mt-3 ">
                    <td colspan="3"></td>
                    <td class="text-end sub_total">
                        Subtotal
                    </td>
                    <td class="text-end f-w-600">
                        ${{getSubTotal(shipStationOrder)??0 | number : '1.2-2'}}
                    </td>
                </tr>
                <tr>
                    <td colspan="3" class="border-0"></td>
                    <td class="text-end sub_total">
                        Tax
                    </td>
                    <td class="text-end f-w-600">
                        ${{getTax(shipStationOrder)??0 | number : '1.2-2'}}
                    </td>
                </tr>
                <tr>
                    <td colspan="3" class="border-0"></td>
                    <td class="text-end sub_total">
                        Shipping
                    </td>
                    <td class="text-end f-w-600">
                        ${{shipOrder(shipStationOrder?.orderKey)?.shipping??0 | number : '1.2-2'}}
                    </td>
                </tr>
                <tr>
                    <td colspan="3" class="border-0"></td>
                    <td class="text-end total">
                        Total:
                    </td>
                    <td class="text-end total">
                        ${{(getSubTotal(shipStationOrder)??0)+(getTax(shipStationOrder)??0)+(shipOrder?.shipping??0) | number : '1.2-2'}}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="print_packing_ship_info flex-column">
        <div class="print_packing_address_info print_packing_ship_to">
            <p class="print_packing_text_info"><b>Bin :</b></p>
            <p class="print_packing_text_info print_packing_ship_to_text ">{{orderDetails?.binName}}</p>
        </div>
        <div class="print_packing_address_info print_packing_ship_to">
            <p class="print_packing_text_info"><b>Wagon :</b></p>
            <p class="print_packing_text_info print_packing_ship_to_text ">{{orderDetails?.wangonName}}</p>
        </div>
    </div>
    <div class="html2pdf__page-break"></div>
</div>